import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { commonTheme } from 'themes/AppThemeProvider';
// import {
//   EpilogueMedium,
//   EpilogueRegular,
//   SFProRoundedMedium
// } from 'themes/appFonts';

const coreTheme = createTheme(
  {
    palette: {
      primary: {
        main: 'rgba(57, 175, 62, 1)',
        light: 'rgba(238, 251, 241, 1)',
        dark: 'rgba(3, 203, 106, 1)'
      },
      secondary: {
        main: 'rgba(235, 91, 84, 1)'
      },
      tertiary: {
        main: 'rgba(3, 203, 106, 1)'
      },
      error: {
        main: 'rgba(255, 44, 44, 1)'
      },
      warning: {
        main: 'rgba(235, 91, 84, 1)'
      },
      background: {
        default: 'rgb(241,241,241)',
        opposite: 'rgb(51,51,51)',
        card: 'rgb(237,237,237)',
        light: 'rgb(255, 255, 255)',
        dark: 'rgb(219,219,219)'
      },
      common: {
        white: 'rgba(255,255,255,1)',
        black: 'rgba(0,0,0,1)'
      },
      text: {
        primary: 'rgb(51, 51, 51)',
        secondary: 'rgba(0, 0, 0, 0.4)',
        tertiary: 'rgba(21, 21, 21, 0.6)',
        contrastText: 'rgb(255, 255, 255)',
        disabled: 'rgb(195, 193, 189)'
      },
      gradient: {
        green:
          'linear-gradient(266.79deg, rgba(57, 175, 62, 0.8) 2.66%, rgba(3, 203, 106, 0.8) 85.83%)',
        primary:
          'linear-gradient(176deg, rgb(102, 190, 123)  0%, rgba(57, 175, 62, 0.8)  33%, rgba(3, 203, 106, 0.8) 100%)',
        grey: 'linear-gradient(95.72deg, #FFFFFF 5.26%, #DEDEDE 98.93%)',
        white: 'linear-gradient(10.96deg, #E7E7E7 2.27%, #FFFFFF 60.54%)'
      },
      action: {
        hover: '#F0F4F4'
      },
      shadows: {
        // box-shadow: offset-x offset-y blur-radius spread-radius color
        lightBlack: '0px 4px 4px 0px rgba(0, 0, 0, 0.21)',
        darkBlack: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
      },
      borderImageSource: {
        white: 'linear-gradient(104.96deg, #E7E7E7 2.27%, #FFFFFF 60.54%)',
        primary:
          'linear-gradient(142.22deg, rgba(57, 175, 62, 0.8)  10.15%, rgba(3, 203, 106, 0.8) '
      }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontFamily:
              '"SF Pro Rounded", Epilogue, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
          }
          // html: {
          //   '--font-stack-latin':
          //     '"SF Pro Rounded", Epilogue, -apple-system, Roboto, Arial, sans-serif',
          //   '--font-stack-cyrillic':
          //     'Roboto, "Segoe UI", Arial, sans-serif, "SF Pro Rounded", Epilogue'
          // },
          // 'html[lang="ru"] body': {
          //   fontFamily: 'var(--font-stack-cyrillic) !important'
          // },
          // 'html:not([lang="ru"]) body': {
          //   fontFamily: 'var(--font-stack-latin)'
          // }
        }
      },
      MuiLink: {
        styleOverrides: {
          root: {
            cursor: 'pointer',
            textDecoration: 'none',
            lineHeight: '16px',
            transition: 'all 0.1s ease-in-out',
            '&:hover': {
              opacity: 0.8
            }
          }
        }
      },
      MuiSkeleton: {
        styleOverrides: {
          root: {
            backgroundColor: '#e0e0e0'
          },
          pulse: {
            animation: 'pulseAnimation 0.8s ease-in-out infinite', // Adjust duration (default is 1.5s)
            '@keyframes pulseAnimation': {
              '0%': { opacity: 0.6 },
              '50%': { opacity: 0.8 },
              '100%': { opacity: 0.6 }
            }
          },
          wave: {
            animation: 'waveAnimation 1s linear infinite', // Adjust duration (default is 1.6s)
            '@keyframes waveAnimation': {
              '0%': { transform: 'translateX(-100%)' },
              '100%': { transform: 'translateX(100%)' }
            }
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            aspectRatio: '1/1'
          }
        }
      },
      MuiButton: {
        variants: [
          {
            props: { variant: 'instavision' },
            style: {
              // background:
              //   'linear-gradient(135deg, #E4E4E4 14.2%, #F5F5F5 84.92%)',
              // border: '0.5px solid #ffffff',
              background:
                'linear-gradient(113deg,rgba(228, 228, 228, 1), rgba(241, 241, 241, 1))  padding-box, linear-gradient(356.14deg, #D5D5D5 9.39%, #FFFFFF 88.07%) border-box',
              border: '1px solid transparent',
              borderRadius: '10000px',
              cursor: 'pointer'
            }
          }
        ],
        styleOverrides: {
          root: ({ ownerState }) => ({
            textTransform: 'none',
            ...(ownerState.variant === 'contained' && {
              padding: coreTheme.spacing(2.5),
              fontSize: coreTheme.typography.body1.fontSize,
              fontWeight: coreTheme.typography.body1.fontWeight,
              lineHeight: coreTheme.typography.body1.lineHeight,
              textTransform: 'capitalize',
              background: 'linear-gradient(135deg, #E4E4E4 100%, #F5F5F5 100%)',
              borderStyle: 'solid !important',
              borderWidth: '1px !important',
              borderRadius: '2rem',
              borderImageSource:
                'linear-gradient(315deg, #D5D5D5 0%, #FFFFFF 100%)',
              boxShadow: '2px 2px 10px -4px rgba(0, 0, 0, 0.08)',
              color: coreTheme.palette.text.primary
              // boxShadow: '3px 3px 6px #b8b9be,-3px -3px 6px #fff'
            })
          })
        }
      },
      MuiTextField: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...(ownerState.variant === 'outlined' && {
              width: '100%',
              fontSize: coreTheme.typography.body1.fontSize,
              fontWeight: coreTheme.typography.body1.fontWeight,
              lineHeight: coreTheme.typography.body1.lineHeight,
              background: coreTheme.palette.background.card,
              border: '0.5px solid',
              borderRadius: '20px',
              borderImageSource:
                'linear-gradient(318.14deg, #D5D5D5 9.39%, #FFFFFF 88.07%)',
              // boxShadow: '3px 3px 6px #b8b9be,-3px -3px 6px #fff'

              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none'
              },
              '& input': {
                padding: coreTheme.spacing(2.5),
                fontSize: coreTheme.typography.body1.fontSize,
                fontWeight: coreTheme.typography.body1.fontWeight,
                lineHeight: coreTheme.typography.body1.lineHeight
              }
            })
          })
        }
      }
    }
  },
  commonTheme
);

const responsiveTheme = responsiveFontSizes(coreTheme);

export default responsiveTheme;
